<template>
  <div v-loading="loading">
    <el-card class="mat12">
      <div class="table_box">
        <div class="table_wrap">
          <div class="table_head">
            <div class="table-th">岗位名称</div>
            <div class="table-th" style="width:200px;flex-shrink: 0;">岗位位置</div>
            <!-- <div class="table-th" style="min-width:98px">岗位配置</div> -->
            <!-- <div class="table-th" style="min-width:98px">人员配置</div> -->
            <div class="table-th" style="width:350px;flex-shrink: 0;">班次列表（上班时间/班）</div>
            <div class="table-th" style="min-width:180px" v-if="notData">
              <span class="table-text">工时</span>
              <el-date-picker
                class="card_table-picker mal20"
                v-model="value"
                type="month"
                placeholder="选择月"
                @change="handleDateValue"
                format="yyyy-MM"
                value-format="yyyy-MM"
                :clearable="false"
              ></el-date-picker>
            </div>
            <div class="table-th"></div>
          </div>
          <div v-for="(item,index) in data" :key="index">
            <div class="table_tbody">
              <div class="table-tb"><span :class="item.delState == 1 ?'grey':''"> {{item.postName}}</span></div>
              <div
                class="table-tb"
                style="width:200px;flex-shrink: 0;"
              ><span :class="item.delState == 1 ?'grey':''"> {{item.position?item.position:'未填写'}}</span></div>
               <!-- <div class="table-tb" style="min-width:98px">
                   <span>{{item.ppc.workType | filterWorkType }}</span>
                     <span v-if="item.ppc.workType == 1" class="red">（{{item.ppc.restDaysOfMonth}} 天）</span>
                </div>
                <div class="table-tb" style="min-width:98px">
                   <span>{{item.ppc.staffType | filterWorkType }}</span>
                     <span v-if="item.ppc.staffType == 1" class="red">（{{item.ppc.staffDaysOfMonth}} 天）</span>
                </div> -->

              <div class="table-tb" style="width:350px;flex-shrink: 0;">
                <span :class="item.delState == 1 ?'grey':''">
                <span
                  class="work_time"
                  v-for="(time,index) in item.ppc.postClass"
                  :key="index"
                >{{time.officeHour}} / {{time.workingTimeCode}}时</span>
                </span>
              </div>
              <div class="table-tb" style="min-width:180px">
                <!-- {{item.postTotalHours?item.postTotalHours:'0'}}小时 -->
                 <span :class="item.delState == 1 ?'grey':''">
                <span
                  class="work_time"
                  v-for="(hours,index) in item.ppc.postHours"
                  :key="index"
                >{{hours.code | getSubCode}}（{{hours.num}} / {{hours.hous}}）小时</span>
                 </span>
              </div>
              <!-- <div
                class="table-tb table_desc"
                @click="handleClickRote(item)"
                :class="{active:item.isShow}"
              >
                <span class="default_color">详情</span>

                <i class="el-icon-arrow-down el-icon--right"></i>
              </div> -->
            </div>
            <div class="table_arrow_data" v-show="item.isShow" v-if="item.ppc">
              <!-- <p class="bc-title">班次配置</p> -->
              <ul class="table_arrow_list">
                <li class="item">
                  <div class="item_flex">
                    <span class="item_day">{{item.ppc.workType == 1 ? '月休天数：':'排班日期：'}}</span>
                    <span
                      class="work_time"
                      v-if="item.ppc.workType == 1"
                    >{{item.ppc.restDaysOfMonth}}天</span>
                    <span class="work_time" v-else>{{item.ppc.workingDays | getWorkDay}}</span>
                  </div>

                  <div class="item_flex">
                    <span class="item_day">班次列表（上班时间 / 班)：</span>
                    <span
                      class="work_time"
                      v-for="(time,index) in item.ppc.postClass"
                      :key="index"
                    >{{time.officeHour}} / {{time.workingTimeCode}}时</span>
                  </div>
                </li>
                <li class="item" v-if="dataDesc.hoursList">
                  <div class="item_flex">
                    <span class="item_day">工时：</span>
                    <span
                      class="work_time"
                      v-for="(hours,index) in item.ppc.postHours"
                      :key="index"
                    >{{hours.code | getSubCode}}（{{hours.num}} / {{hours.hous}}）小时</span>
                  </div>
                </li>
              </ul>
              <!-- </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="card_footer_info" v-if="dataDesc.hoursList">
        <div class="footer_bc">
          <span class="font_word">合计总工时：</span>
          <span
            v-for="(item,index) in hoursList"
            :key="index"
          >{{item.name}} （{{item.num}} / {{item.hous}}）小时 &nbsp;&nbsp;</span>
        </div>
        <!-- <div class="footer_gs">{{totalHours}}小时</div> -->
      </div>
    </el-card>
  </div>
</template>

<script>
import { projectTotalHours } from '@/api/project'
export default {
  name: 'CardScheduleSetting',
  props: {
    dataDesc: {
      type: Object,
      default: () => {
        return {}
      }
    },
    notData: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      data: {},
      value: '',
      loading: false,
      hoursList: [], // 表示几个班次
      totalHours: '', // 总时长
      totalNum: '' // 总人数
    }
  },

  created () {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    this.value = year + '-' + month

    this.totalHours = this.dataDesc.totalHours
    this.totalNum = this.dataDesc.totalNum
    this.getListPost(this.dataDesc.post)
    if (this.dataDesc.hoursList) {
      this.gethoursList(this.dataDesc.hoursList)
    }
    this.id = this.$route.params.id
    // 可以先不调用
    // this._handleWorkDate();
  },
  filters: {
    // 截取字母
    getSubCode (val) {
      let index = val.indexOf('（')
      let name = val.substr(0, index)
      return name
    },
    getWorkDay: function (value) {
      let val = value
      let arr = []
      if (!val) {
        return val
      }

      if (!Array.isArray(val)) {
        val = val.split(',')
      }
      val.forEach((week) => {
        if (week == 1) {
          week = '星期一'
        }
        if (week == 2) {
          week = '星期二'
        }
        if (week == 3) {
          week = '星期三'
        }
        if (week == 4) {
          week = '星期四'
        }
        if (week == 5) {
          week = '星期五'
        }
        if (week == 6) {
          week = '星期六'
        }
        if (week == 7) {
          week = '星期日'
        }
        arr.push(week)
      })
      return arr.join(',')
    },
    filterWorkType: function (value) {
      let str = Number(value)
      if (str === 0) {
        return '月休四天'
      }
      if (str === 1) {
        return '其他'
      }
      if (str === 2) {
        return '三包一'
      }
      if (str === 3) {
        return '二包一'
      }
      if (str === 4) {
        return '工作日上班'
      }
      if (str === 5) {
        return '上一休一'
      }
      if (str === 6) {
        return '周日休息'
      }
      if (str === 7) {
        return '上二休一'
      }
      if (str === 8) {
        return '上三休一'
      }
      if (str === 9) {
        return '上六休一'
      }
      if (str === 10) {
        return '月休15天'
      }
      if (str === 11) {
        return '周六周日上班'
      }
      if (str === 12) {
        return '四包一'
      }
    }
  },
  methods: {
    // 获取岗位及工时处理
    getListPost (val) {
      this.data = val.map((item) => {
        item.isShow = false
        // 如果ppc存在
        item.ppc = item.ppc ? item.ppc : []
        return item
      }).sort((a, b) => {
        return a.delState - b.delState
      })
      // .filter(item => {
      //   return item.delState !== 1
      // })
    },
    // 获取总工时
    gethoursList (val) {
      this.hoursList = val.map((item) => {
        let index = item.code.indexOf('（')
        let name = item.code.substr(0, index)
        return {
          num: item.num,
          hous: item.hous,
          code: item.code,
          name: name
        }
      })
    },
    getPostType (postType) {
      switch (postType) {
        case 1:
          return '普通保安岗'
        case 2:
          return '形象岗'
        case 3:
          return '中控岗'
        case 4:
          return '班长岗'
        case 5:
          return '副队长岗'
        case 6:
          return '兼职队长岗'
        case 7:
          return '专职队长岗'
        default:
          return '普通保安岗'
      }
    },
    handleClickRote (item) {
      if (item.ppc && item.ppc.postName) {
        let index = this.data.indexOf(item)
        item.isShow = !item.isShow
        this.data.splice(index, 1, item)
      } else {
        this.$message.warning('没有班次配置')
      }
      // console.log(this.data);
    },
    // 获取工时状况
    getList () {
      let _self = this
      _self.loading = true
      let data = {
        id: this.id,
        date: this.value
      }
      projectTotalHours(data)
        .then((res) => {
          _self.loading = false
          _self.totalHours = res.data.totalHours
          _self.getListPost(res.data.post)
          _self.gethoursList(res.data.hoursList)
        })
        .catch((err) => {
          _self.loading = false
          console.log(err)
        })
    },
    handleDateValue (val) {
      this.getList()
    },
    _handleWorkDate () {
      if (!this.id) {
        return this.$message.warning('地址错误！')
      }

      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  font-weight: bold;
  color: #333;
  padding: 0 10px 10px;
  .team {
    font-weight: 400;
  }
}

.table_box {
  width: 100%;
  padding-bottom: 20px;
  .table_head {
    width: 100%;
    border-bottom: 1px solid #ebeef5;
    padding: 12px;
    line-height: 30px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: nowrap;
    box-sizing: border-box;
    .table-th {
      color: #909399;
      font-weight: bold;
      min-width: 7%;
      margin-right: 1%;
    }
  }
  .table-text {
    color: #909399;
    font-weight: bold;
  }
  .table_tbody {
    width: 100%;
    overflow: hidden;
    border-bottom: 1px solid #ebeef5;
    padding: 12px;
    display: flex;
    // justify-content: space-between;
    box-sizing: border-box;
    flex-wrap: nowrap;

    .table-tb {
      color: #333;
      min-width: 7%;
      margin-right: 1%;
    }
  }

  .table_desc {
    cursor: pointer;

    i {
      transition: transform 0.2s ease-in-out;
    }
  }
  .table_desc.active {
    i {
      transform: rotate(180deg);
    }
  }
  .table_arrow_data {
    padding: 20px 12px;
    border-bottom: 1px solid #ebeef5;

    .table_arrow_list {
      .item {
        // padding: 0 0 15px 0;
        margin: 15px 0;
        height: auto;
        overflow: hidden;
        .name {
          font-size: #333;
        }
      }
      .item_flex {
        // max-width: 50%;
        margin: 5px 0;
        float: left;
      }
      .item_day {
        color: #999;
      }
      span {
        padding: 0 10px 0 0;
      }
      i {
        font-style: normal;
      }
    }
  }
}
.bc-title {
  // width: 56px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999;
  line-height: 40px;
}
.card_footer_info {
  padding: 5px 12px;
//   display: flex;
  display: -webkit-box;
  overflow: auto;
  .footer_bc {
    color: #333;
    // width: calc(42% + 298px);
    // width: calc(27% + 298px + 120px);
    // width: calc(24% + 298px);
  }
  .font_word,
  .footer_ht,
  .footer_gs {
    font-weight: bold;
  }
  .footer_ht {
    width: 8%;
    margin-right: 8%;
  }
}

@media screen and (max-width: 880px) {
  .table_box {
    overflow-x: scroll;
  }
  .table_box .table_head .table-th {
    min-width: 58px;
  }
  .table_box .table_tbody .table-tb {
    min-width: 58px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    // border-top: 1px solid #ebeef5;
  }
  .table_box .table_head .table-th {
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
  }
  .table_box .table_head {
    border-bottom: none;
  }
  .table_box .table_arrow_data {
    border-bottom: none;
  }
  .table_box .table_tbody {
    overflow: initial;
    border-bottom: none;
  }
}
.work_time{
  padding-right: 10px;
}
</style>
<style lang="scss">
.card_table-picker {
  width: 120px !important;
  .el-input__inner {
    height: 30px;
    line-height: 30px;
    width: 120px;
  }

  .el-input__icon {
    line-height: 32px;
  }
}
</style>
